import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import StaticSearch from 'Containers/StaticSearch/StaticSearch';
import { fetchEndingSoon } from 'Redux/ducks/algolia-calls';

const messages = defineMessages({
  title: {
    id: 'endingsoon.title',
    defaultMessage: 'Ending Soon',
  },
  fullTitle: {
    id: 'endingsoon.seotitle',
    defaultMessage: 'Ending Soon | Last Chance PC Game Deals',
  },
  desc: {
    id: 'endingsoon.seodesc',
    defaultMessage: 'Last chance to get these amazing Steam game deals. We are Fanatical about always bringing you the best deals on the planet from top publishers like Bethesda, Warner Bros, 2K, SEGA and more!',
  },
  pcGameDeals: {
    id: 'endingsoon.pcgamedeals',
    defaultMessage: 'PC Game Deals',
  },
});

export default function EndingSoon() {
  const { formatMessage } = useIntl();

  const crumbs = [{
    label: formatMessage(messages.pcGameDeals),
    link: '/on-sale/',
  },
  {
    label: formatMessage(messages.title),
    link: '/ending-soon',
  },
  ];

  return (<StaticSearch
    updateHits={fetchEndingSoon}
    url="ending-soon"
    topBanner="ending_soon"
    seoBlurb={messages.desc}
    crumbs={crumbs}
    {...messages}
  />);
}
